import React, { Fragment } from "react";
import { Stack, Typography } from "@mui/material";
import { UpdateEmailForm } from "./UpdateEmailForm";
import { UpdatePasswordForm } from "./UpdatePasswordForm";
import { TakeProfileOffline } from "./TakeProfileOffline";
import { SettingsDeleteAccount } from "./SettingsDeleteAccount";
import useStore from "../../../states/store";
import { PAGE_PERMISSIONS } from "../../../enums/permissions/permission";
const {
  CAN_VIEW_CHANGE_EMAIL_SECTION,
  CAN_VIEW_CHANGE_PASSWORD_SECTION,
  CAN_VIEW_TOGGLE_PROFILE_OFFLINE_SECTION,
  CAN_VIEW_DELETE_ACCOUNT_SECTION
} = PAGE_PERMISSIONS;

const SettingsPage = () => {
  const [, { hasPermission }] = useStore();
  return (
    <Fragment>
      <Typography variant="h5" fontWeight={700} color="primary.main" mb={1.5}>Settings</Typography>
      <Stack gap={2}>
        {hasPermission(CAN_VIEW_CHANGE_EMAIL_SECTION) && <UpdateEmailForm />}
        {hasPermission(CAN_VIEW_CHANGE_PASSWORD_SECTION) && <UpdatePasswordForm />}
        {hasPermission(CAN_VIEW_TOGGLE_PROFILE_OFFLINE_SECTION) && <TakeProfileOffline />}
        {hasPermission(CAN_VIEW_DELETE_ACCOUNT_SECTION) && <SettingsDeleteAccount />}
      </Stack>
    </Fragment>
  );
};

export default SettingsPage;